import React from "react"
import { Center, Flex, Stack, Title } from "@mantine/core"

import { useStyles } from "@/components/FormStep/FormStep.styles"

export interface FormStepProps {
    children: React.ReactNode
    /** Text to show underneath the step circle */
    label: string
    /** Content to show inside the step circle */
    step: string | number
}

export const FormStep = ({ children, label, step }: FormStepProps) => {
    const { classes } = useStyles()

    return (
        <Flex className={classes.container}>
            <Flex className={classes.formStep}>
                <Flex className={classes.indexSection}>
                    <Center className={classes.number}>{step}</Center>
                    <Title order={2} className={classes.title}>
                        {label}
                    </Title>
                </Flex>

                <Stack spacing="xl" className={classes.contentSection}>
                    {children}
                </Stack>
            </Flex>
        </Flex>
    )
}
